import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../../../tailwind.config'

export function useTheme() {
  const { theme } = resolveConfig<typeof tailwindConfig>(tailwindConfig)

  return { theme }
}
